import React, { useContext, useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { fetchFromStorage } from "src/helpers/context/Storage";
import { createStyles, makeStyles } from "@mui/styles";
import { IntlContext } from "src/App";
import { trackActivity } from "src/helpers/context/sentry";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: "500px",
      margin: "30px 0",
      textAlign: "center",
      "& .iframe_form": {
        minHeight: "100vh",
        width: "100%",
        border: 0,
      },
      "& .MuiButton-root": {
        height: "36px",
        fontSize: "14px",
        padding: "6px 18px",
      },
      "& .locked_user": {
        textAlign: "left",
        maxWidth: "480px",
        margin: "0 auto 20px",
        padding: "16px 18px",
        border: "1px solid #D4D4D4",
        borderRadius: "8px",
        background: "#F7F7F7",
        boxSizing: "border-box",
        "& .label": {
          fontSize: "13px",
          color: "#707070",
          marginBottom: "4px",
          fontFamily: "'Montserrat', sans-serif",
        },
        "& .value": {
          fontSize: "16px",
          color: "#373737",
          fontWeight: 500,
          fontFamily: "'Montserrat', sans-serif",
          wordBreak: "break-all",
        },
      },
    },
  })
);

const getNameParts = (user) => {
  const first =
    user?.firstName ||
    (user?.name ? String(user.name).trim().split(/\s+/)[0] : "") ||
    "";
  const last =
    user?.lastName ||
    (user?.name
      ? String(user.name).trim().split(/\s+/).slice(1).join(" ")
      : "") ||
    "";
  return { first, last };
};

const TestForm = () => {
  const classes = useStyles();
  const location = useLocation();
  const intlContext = useContext(IntlContext);
  const gothe_mile = intlContext?.messages;
  const redux_auth = useSelector((state) => state.ActionReducer.authdata);
  const auth = redux_auth ? redux_auth : fetchFromStorage("authdata");
  const lastSegment = location.pathname.split("/").pop();
  const lastSegment2 = location.pathname.split("/")[2];
  const type = "web";
  const { state } = useLocation();
  const formRef = useRef(null);

  const user = auth?.data;
  const { first, last } = getNameParts(user || {});
  const email = user?.email || "";

  const quizParams = useMemo(() => {
    const params = {
      quiz: lastSegment2,
      cm_access_list_item: type,
    };

    if (user) {
      params.cm_fn = first;
      params.cm_ln = last;
      params.cm_e = email;
      params.cm_user_id = state?.orderId
        ? `${lastSegment}-${user._id}-${state.orderId}`
        : `${lastSegment}-${user._id}`;
    } else {
      params.cm_user_id = lastSegment;
    }

    return params;
  }, [lastSegment, lastSegment2, user, first, last, email, state?.orderId]);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
      trackActivity("test.started", {
        quiz_id: lastSegment2,
        product_id: lastSegment,
        order_id: state?.orderId || null,
        classmarker_user_id: quizParams?.cm_user_id,
        user_id: user?._id || null,
        user_email: email || null,
        user_name: user?.name || null,
        is_free_test: !state?.orderId,
        source: state?.orderId ? "purchased" : "free_or_direct",
        path: location.pathname,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizParams]);

  useEffect(() => {
    const startedAt = Date.now();
    return () => {
      trackActivity("test.session_ended", {
        quiz_id: lastSegment2,
        product_id: lastSegment,
        order_id: state?.orderId || null,
        user_id: user?._id || null,
        user_email: email || null,
        duration_ms: Date.now() - startedAt,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box className="main_container">
        <Box className={classes.root}>
          {user && (
            <Box className="locked_user">
              <Typography className="label">
                {gothe_mile?.email_address || "Email"}
              </Typography>
              <Typography className="value">{email}</Typography>
              <Typography
                sx={{
                  mt: 1,
                  fontSize: "12px",
                  color: "#707070",
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Email is locked to your account and cannot be changed for this
                test.
              </Typography>
            </Box>
          )}

          <form
            ref={formRef}
            action="https://www.classmarker.com/online-test/start/"
            method="post"
            target="classmarker_test_frame"
            style={{ display: "none" }}
          >
            {Object.entries(quizParams).map(([key, value]) => (
              <input
                key={key}
                type="hidden"
                name={key}
                value={value == null ? "" : String(value)}
              />
            ))}
          </form>

          <iframe
            name="classmarker_test_frame"
            title="ClassMarker test"
            className="iframe_form"
            src="about:blank"
          />

          {auth ? (
            <Box sx={{ mt: "40px" }}>
              <Button variant="blue" href="/dashboard">
                {gothe_mile?.goBackDashboard}
              </Button>
            </Box>
          ) : (
            <Box sx={{ mt: "40px" }}>
              <Button variant="blue" href="/testfree">
                {gothe_mile?.goBackFreeTest}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
export default TestForm;
